// src/services/supervisorService.js

import apiClient from './apiClient'; // On utilise notre client axios configuré

const SUPERVISORS_API_URL = '/api/v1/supervisors'; // L'URL de base pour ce module

/**
 * Récupère la liste de tous les superviseurs avec leurs détails.
 * @returns {Promise<Object>} La réponse de l'API.
 */
export const fetchAllSupervisors = () => {
  return apiClient.get(SUPERVISORS_API_URL);
};

/**
 * Crée un nouveau superviseur.
 * @param {Object} supervisorData - Les données du superviseur à créer (email, password, firstName, lastName, name).
 * @returns {Promise<Object>} La réponse de l'API avec le superviseur créé.
 */
export const createNewSupervisor = (supervisorData) => {
  return apiClient.post(SUPERVISORS_API_URL, supervisorData);
};

/**
 * Assigne une liste de délégués à un superviseur spécifique.
 * @param {number} supervisorId - L'ID du superviseur à qui assigner les délégués.
 * @param {number[]} delegateIds - Un tableau contenant les IDs des délégués à assigner.
 * @returns {Promise<Object>} La réponse de l'API avec le profil superviseur mis à jour.
 */
export const assignDelegates = (supervisorId, delegateIds) => {
  const url = `${SUPERVISORS_API_URL}/${supervisorId}/assign-delegates`;
  // Le corps de la requête contient le tableau d'IDs
  return apiClient.post(url, { delegateIds });
};

// Vous pouvez ajouter ici d'autres fonctions si besoin (ex: deleteSupervisor, updateSupervisor)